import { render, staticRenderFns } from "./TriggerDescription.vue?vue&type=template&id=19db702b&"
import script from "./TriggerDescription.vue?vue&type=script&lang=js&"
export * from "./TriggerDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports